<template>
    <SecondaryPage :showLangSwitchBtn="false">
        <div class="relative max-full-hd">
            <BackButtonDesktop customClass="absolute left-6 " @clickBack="clickBack()"></BackButtonDesktop>
            <div class="max-w-sm m-auto px-4">
                <div class="text-18 text-a-brown-502314 font-bold text-center mt-6">{{lbl.login.please_setup_pin}}</div>
                <div class="mt-3">
                    <img class="w-8 m-auto" src="../../../assets/password/ic-lock.svg">
                </div>
                <div class="mt-3 text-a-brown-502314 text-14 text-center">
                    {{lbl.login.enter_your_pin}}
                </div>
                <InputPin
                        ref="input-pin"
                        v-model:inputValue="password"
                        @update:inputValue="onInputPassChange()"
                ></InputPin>
                <router-link to="/resetpassword" class="block text-a-red-d62300 font-bold text-16 text-center cursor-pointer mt-8">
                    Forgot PIN?
                </router-link>
            </div>
        </div>
    </SecondaryPage>
</template>
<script>
import Account from '@/helper/AccountHelper.js';
import Util from '@/helper/Utility.js';
import CacheHelper from '@/helper/CacheHelper.js';
import { CacheKey } from '@/helper/StaticValue.js';
//component
import SecondaryPage from '@/components/Layout/Page/SecondaryPage.vue'
import BackButtonDesktop from '@/components/Button/BackButtonDesktop.vue'
import InputPin from '@/components/Input/simple/InputPin.vue'
//mixin
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from "@/mixin/LocaleMixin.js";
//service
import { AuthLoginConfigBuilder } from '@/core/Account/config/AuthConfigModel';
import BzbsAuth from '@/core/Account/service/BzbsAuth';
import LoginAccountApi from '../service/LoginAccountApi';

export default {
    mixins: [ModalMixin,LocaleMixin],
    components: {
        SecondaryPage,
        BackButtonDesktop,
        InputPin,
    },
    data: function () {
        return {
            tel: '',
            username: '',
            password: '',
            email: '',

            isLoading: false,
            userskip: Account.getUserId()
        };
    },
    created: function () {
        this.getUsername();
        let afterLogin = this.$route.query.afterLogin;
        if (!Util.isEmptyStr(afterLogin)) {
            this.pathAfterLogin = afterLogin;
        }

        setTimeout(()=> {
            this.$refs['input-pin'].focus();
        },200);

    },
    methods: {
        getUsername: function () {
            let cache = new CacheHelper('session');
            let data = cache.getCache(CacheKey.loginUsername);
            this.tel = data?.username ?? '';
        },
        clearCacheUserLogin: function () {
            let cache = new CacheHelper('session');
            cache.removeCache(CacheKey.loginUsername);
        },

        onInputPassChange: function () {
            console.log('password input', this.password);
            console.log('password length', this.password.length);
            if (this.password.length == 6) {
                this.submitLogin();
            }
        },

        submitLogin: async function () {
            if (this.isLoading) {
                return;
            }
            this.isLoading = true;

            console.log('username ', this.tel);
            console.log('password ', this.password);

            this.modal.loadingModal.show();
            let accountStatus = await this.checkAccountPasswordStatus()
            if (accountStatus == null) {
                this.isLoading = false;
                this.modal.loadingModal.hide();
                return;
            }
            this.email = accountStatus.username

            let rs = await this.apiLogin();
            this.modal.loadingModal.hide();

            if (rs) {
                await this.syncCart()
                this.clearCacheUserLogin();
                this.afterLoginRedirect();
            }

            this.isLoading = false;
            this.$refs['input-pin'].clearInput();
        },

        apiLogin: function () {
            return new Promise((resolve) => {
                let loginParams = new AuthLoginConfigBuilder()
                    .setUsername(this.email)
                    .setPassword(this.password)
                    .create()
                    .getParams()
                BzbsAuth.apiLogin(loginParams).subscribe({
                    next: (data) => {
                        console.log(data);
                        Account.setLogin(data);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        console.log(err)
                        if(err.code == 403) {
                            let user_delete = { id:'user_delete', message:this.lbl.error_user_delete }
                            this.errorApi(user_delete);
                        } else {
                            this.errorApi(err);
                        }
                    },
                })
            });
        },

        syncCart: function () {
            return new Promise((resolve) => {
                LoginAccountApi.syncCart(this.userskip).subscribe({
                    next: (data) => {
                        console.log(data);
                        resolve(data);
                    },
                    error: (err) => {
                        resolve(null);
                        this.errorApi(err);
                    },
                });
            });
        },

        checkAccountPasswordStatus: function () {
            return new Promise((resolve) => {
                LoginAccountApi.checkAccountLoginStatus(this.tel).subscribe({
                    next: (data) => {
                        console.log(data);
                        resolve(data);
                    },
                    error: (err) => {
                        resolve(null);
                        this.errorApi(err);
                    },
                });
            });
        },

        afterLoginRedirect: function () {
            if (this.pathAfterLogin == null) {
                window.location.replace('/home');
                // this.$router.replace('/home');
            } else {
                window.location.replace(this.pathAfterLogin);
                // this.$router.replace(this.pathAfterLogin);
            }
        },
        clickBack: function () {
            this.$router.back();
        }
    },
}
</script>
<style lang="scss" scoped>
@import '@/style/base/display.scss';
</style>
